import { AbstractDataProviderV2 } from 'components/system';
import { RsCustomerCounter } from 'common/customers/services/types/RsCustomerCounter';
import { CustomerCounterAdd } from 'common/customers/services/types/CustomerCounterAdd';
import { CustomerCounterUpdate } from 'common/customers/services/types/CustomerCounterUpdate';
import { RsCustomerCounterInfo } from 'common/customers/services/types/RsCustomerCounterInfo';

export class CustomerCounterDataProvider extends AbstractDataProviderV2<
    RsCustomerCounter,
    RsCustomerCounterInfo,
    CustomerCounterAdd,
    CustomerCounterUpdate
> {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/dict/counters');
    }

    public add(item, transport?) {
        if (this._outOfRange(item.curValue, item.minValue, item.maxValue)) {
            item.curValue = item.minValue;
        }
        return super.add(item, transport);
    }

    public update(item, transport) {
        if (this._outOfRange(item.curValue, item.minValue, item.maxValue)) {
            item.curValue = item.minValue;
        }
        return super.update(item, transport);
    }

    private _outOfRange(value, minValue, maxValue) {
        value = parseInt(value, 10);
        return isNaN(value) || value < minValue || value > maxValue;
    }

    public patch(): Promise<null> {
        return Promise.reject('Method is not supported');
    }
}
